import hatsApi from '@/services/hatsApi'

export default {
  /**
   * Get conditions request
   * @param {{property: string, value: string}[]} params
   * @param {string} limit
   * @param {string} currentPage
   * @returns {promise} Axios request
   */
  getConditions (filter = '', pageSize = '', currentPage = '') {
    let pagination = pageSize ? '&pageSize=' + pageSize : ''
    pagination += currentPage ? '&page=' + currentPage : ''

    return hatsApi().get('/master-data/condition/?filter=' + JSON.stringify(filter) + pagination)
  },
  /**
   * Get conditions by ID request
   * @param {string | number} id
   * @returns {promise} Axios request
   */
  getConditionsById (id) {
    return hatsApi().get('/master-data/condition/' + id)
  },
  /**
   * Create conditions request
   * @param {{name: string, content: string}} params
   * @returns {promise} Axios request
   */
  createConditions (params) {
    return hatsApi().post('/master-data/condition', params)
  },
  /**
   * Update conditions request
   * @param {string | number} id
   * @param {{name: string, content: string}} params
   * @returns {promise} Axios request
   */
  updateConditions (id, params) {
    return hatsApi().put('/master-data/condition/' + id, params)
  },
  /**
   * Delete conditions request
   * @param {string | number} id
   * @returns {promise} Axios request
   */
  deleteConditions (id) {
    return hatsApi().delete('/master-data/condition/' + id, { data: { id: id } })
  }
}



// WEBPACK FOOTER //
// ./src/services/hatsApi/Conditions.js